import { icons } from "@grindex-common/helpers/constants";
import { $elementChild } from "@grindex-common/helpers/elements";
import { outerHeight, addListener } from "@grindex-common/helpers/domManipulation";

const DIDYOUKNOW_BREAKPOINT = "300";

function init($views) {
	$views.forEach(($cardBlock) => {
		var layerTopPos;
		var layerTopPosOpen;

		const $figure = $cardBlock.querySelector("figure");
		const $didYouKnowTitle = $cardBlock.querySelector("header");
		const $didYouKnowLayer = $cardBlock.querySelector("aside");

		const isSmallFormat = getComputedStyle($cardBlock).width < DIDYOUKNOW_BREAKPOINT;
		const $didYouKnowHeader = $elementChild($cardBlock, "did-you-know-header");

		addListener($didYouKnowHeader, "click", toggleLayer);

		// Small cards in any context should not display a "Did You Know" layer
		if ($didYouKnowLayer && isSmallFormat) {
			$didYouKnowLayer.remove();
		}

		render();

		/**
		 * This function causes all of the DOM Object size calculations to be redone at the moment
		 * user switches to a tab containing this component
		 */
		function render() {
			if (!$didYouKnowTitle || !$didYouKnowLayer) {
				return;
			}

			const figureHeight = outerHeight($figure);
			const didYouKnowTitleHeight = outerHeight($didYouKnowTitle);
			const didYouKnowLayerHeight = outerHeight($didYouKnowLayer);
			layerTopPos = figureHeight - didYouKnowTitleHeight;

			layerTopPosOpen = figureHeight - didYouKnowLayerHeight;

			// Assign initial layer position based on the height of the 'did you know?' titlebar
			$didYouKnowLayer.style.top = `${layerTopPos}px`;
		}

		function toggleLayer() {
			// Change layer's top position so that the entire layer is visible (or return it to its original position)
			const isLayerTopPos = parseFloat($didYouKnowLayer.style.top) === layerTopPos;
			const remove = isLayerTopPos ? icons.plus : icons.minus;
			const add = isLayerTopPos ? icons.minus : icons.plus;
			const topPosition = isLayerTopPos ? layerTopPosOpen : layerTopPos;

			$didYouKnowLayer.style.top = `${topPosition}px`;
			$didYouKnowHeader.classList.add(add);
			$didYouKnowHeader.classList.remove(remove);
		}
	});
}

export default {
	view: "genericCardBlock",
	init,
};
